import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
export var imageSliderBehavior = function imageSliderBehavior() {
  Alpine.data('imageSliderBehavior', function () {
    return {
      imageSlider: undefined,
      imageOverlay: undefined,
      sliderHandle: undefined,
      isDragging: false,
      init: function init() {
        this.imageSlider = this.$el;
        this.imageOverlay = this.imageSlider.querySelector('#image-overlay');
        this.sliderHandle = this.imageSlider.querySelector('#slider-handle');
        this.updateSliderPosition();
      },
      imageSliderBind: {
        // eslint-disable-next-line func-names
        '@mousedown': function mousedown(e) {
          this.isDragging = true;
          this.updateSliderPosition(e.clientX);
          this.sliderHandle.style.opacity = '75%';
        },
        // eslint-disable-next-line func-names
        '@mousemove': function mousemove(e) {
          if (!this.isDragging) return;
          this.updateSliderPosition(e.clientX);
        },
        // eslint-disable-next-line func-names
        '@mouseup': function mouseup() {
          this.isDragging = false;
          this.sliderHandle.style.opacity = '100%';
        }
      },
      imageSliderHandleBind: {
        // eslint-disable-next-line func-names
        '@mousedown': function mousedown(e) {
          this.isDragging = true;
          this.updateSliderPosition(e.clientX);
        },
        // eslint-disable-next-line func-names
        '@touchstart': function touchstart(e) {
          this.isDragging = true;
          this.updateSliderPosition(e.touches[0].clientX);
        },
        // eslint-disable-next-line func-names
        '@touchmove': function touchmove(e) {
          if (!this.isDragging) return;
          this.updateSliderPosition(e.touches[0].clientX);
        },
        // eslint-disable-next-line func-names
        '@touchend': function touchend() {
          this.isDragging = false;
        },
        // eslint-disable-next-line func-names
        '@keydown': function keydown(e) {
          var step = 1;
          var newPercentage;
          if (e.key === 'ArrowLeft') {
            newPercentage = Math.max(0, parseFloat(this.imageOverlay.style.width || '50') - step);
          } else if (e.key === 'ArrowRight') {
            newPercentage = Math.min(100, parseFloat(this.imageOverlay.style.width || '50') + step);
          } else {
            return;
          }
          this.imageOverlay.style.width = "".concat(newPercentage, "%");
          this.sliderHandle.style.left = "".concat(newPercentage, "%");
          e.preventDefault();
        }
      },
      updateSliderPosition: function updateSliderPosition(x) {
        var sliderDimensions = this.imageSlider.getBoundingClientRect();
        var sliderWidth = sliderDimensions.width;
        var sliderPosition = Math.max(0, Math.min(x - sliderDimensions.left, sliderWidth));
        var sliderPercentage = sliderPosition / sliderWidth * 100;
        this.imageOverlay.style.width = "".concat(sliderPercentage, "%");
        this.sliderHandle.style.left = "".concat(sliderPercentage, "%");
      }
    };
  });
};